module.exports = __webpack_public_path__ + "static/media/5.b40026f9.png";